/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 02/10/2022
 *
 */

import React from 'react';
import '../../form-elements/formElement.css';
import API from "../../../../../utils/api";
import EventEmitter from "../../../../../eventEmmiters/EventEmitter";
import Loader from "../../../loader/loader";
import './viewError.css';

/**
 * HOC for the partner form
 */
class ViewErrorDisplay extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            // main partner fields
            outcomesErrorId: null,
            outComesErrorMsgData: '',
            errors: {},
            // user token
            token: '',
            isDisplayLoader: true
        };

        // set icons to the header
        EventEmitter.emit('setPageHeaderData', {
            page: 'view-error',
            pageName: "View Errors",
            pageLink: process.env.REACT_APP_BASE_URL + "/#/home/view-error",
            optionalIcons: ['backIcon']
        });
        EventEmitter.on('navigateToPreviousPage', this.navigateToPreviousPage);
    }

    componentDidMount = async () => {
        // get parameter from URL
        const outcomesErrorId = this.props.match.params.id;

        // get token
        const user = JSON.parse(localStorage.getItem('tmcUser'));
        const token = 'Bearer ' + user.token;

        const oldState = Object.assign({}, this.state);

        // fill the form if not a create partner
        if (outcomesErrorId !== undefined) {
            const url = '/view-error?search=%7BoutcomesErrorId:' + outcomesErrorId + '%7D';

            await API.get(url, {headers: {Authorization: token}}).then(res => {

                const data = res.data[0];
                oldState.outcomesErrorId = (data.outcomesErrorId !== undefined) ? data.outcomesErrorId : null;
                oldState.outComesErrorMsgData = (data.outComesErrorMsgData !== undefined) ? data.outComesErrorMsgData : null;
                oldState.token = token;
                oldState.isDisplayLoader = false;

                this.setState(oldState);
            }).catch(er => {
                oldState.isDisplayLoader = false;
                this.setState(oldState);

                if (er.response === undefined) {
                    localStorage.removeItem('tmcUser')
                    this.props.history.push('/');
                } else {
                    this.setAlert("Error", "Error", "Sorry! Unable to load Error details");
                }
            });
        } else {
            oldState.token = token;
            oldState.isDisplayLoader = false;
            this.setState(oldState);
        }
    };

    componentWillUnmount = () => {
        EventEmitter.off('setPageHeaderData', {});
        EventEmitter.off('navigateToPreviousPage', this.navigateToPreviousPage);
    };

    setAlert = (alertType, alertTitle, alertMessage) => {
        EventEmitter.emit('setAlert', {
            openAlert: true,
            type: alertType,
            isDisplayAlertIcon: true,
            alertMessage: alertMessage,
            alertTitle: alertTitle
        });
    };

    navigateToPreviousPage = () => {
        this.props.history.push('/home/view-error');
    };

    render() {
        return(
            <div role="form" className="view-error-display-container">
                {this.state.isDisplayLoader && <Loader/>}
                <fieldset key={this.state.outComesErrorMsgData} className="fieldParent">
                    <fieldset>
                        <textarea
                            value={this.state.outComesErrorMsgData}
                            disabled={true}
                        />
                    </fieldset>
                </fieldset>
            </div>
        )
    }
}

export default ViewErrorDisplay;
